import { createRoot } from 'react-dom/client'

// third party
import { Provider } from 'react-redux'

// project imports
import App from './App'

// google-fonts
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/700.css'

import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'

import 'assets/scss/style.scss'
import reportWebVitals from 'reportWebVitals'

import Notification from './components/Notification'

import store from './store/store'
const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <App />
    <Notification />
  </Provider>
)

reportWebVitals()
